const API = {
  POST_CREATE_ENT_ACC: {
    path: '/ent-account/create',
    method: 'POST',
  },
  GET_STRIPE_PLATFORM_REGIONS: {
    path: '/stripe/platform-regions',
    method: 'GET',
  },

};
export default API;
